import { useState } from 'react';
import classNames from 'classnames/bind';
import { DateTime } from 'luxon';

import { timeFormatter } from '@autopass-web/domain';

import { PaymentPriceRateHintDialog } from '../payment-price-rate-hint-dialog';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface ParkingInfoSectionProps {
  checkedInAt: string;
  checkedOutAt: string;
  requestAmount: string;
  shouldLeaveBefore: string;
  currentPricePeriod: string[];
  amplitudeEventParams: { ticketId: string; plateNumber: string };
}

export const ParkingInfoSection = ({
  checkedInAt,
  checkedOutAt,
  requestAmount,
  shouldLeaveBefore,
  currentPricePeriod,
}: ParkingInfoSectionProps) => {
  const [
    isPaymentPriceRateHintDialogOpen,
    setIsPaymentPriceRateHintDialogOpen,
  ] = useState<boolean>(false);

  const listData: { label: string; value: string; isAmount?: boolean }[] = [
    {
      label: '停車時數',
      value: formatParkingDuration({ checkedInAt, checkedOutAt }),
    },
    {
      label: '付款金額',
      value: `${Math.round(+requestAmount)} 元`,
      isAmount: true,
    },
    {
      label: '最晚離場時間',
      value: timeFormatter(shouldLeaveBefore, 'day'),
    },
  ];

  return (
    <>
      <div className={styles.bottom}>
        {listData.map(({ label, value, isAmount }) => {
          return (
            <div key={`${label}_${value}`} className={styles.list}>
              <div
                className={cx({
                  name: true,
                })}
              >
                {label}
                {isAmount}
              </div>
              <div
                className={cx({
                  value: true,
                  amount: isAmount,
                })}
              >
                {value}
              </div>
            </div>
          );
        })}
      </div>
      <PaymentPriceRateHintDialog
        messages={currentPricePeriod}
        isOpen={isPaymentPriceRateHintDialogOpen}
        onButtonClick={() => setIsPaymentPriceRateHintDialogOpen(false)}
      />
    </>
  );
};

function formatParkingDuration({
  checkedInAt,
  checkedOutAt,
}: {
  checkedInAt: string;
  checkedOutAt: string;
}) {
  const { days, hours, minutes } = DateTime.fromISO(checkedOutAt)
    .diff(DateTime.fromISO(checkedInAt), ['days', 'hours', 'minutes'])
    .toObject();

  const dayString = days !== 0 ? `${days} 天` : '';
  const hourString = hours !== 0 ? `${hours} 小時` : '';
  const minString = minutes !== 0 ? `${Math.ceil(minutes)} 分` : '';

  const result = `${dayString} ${hourString} ${minString}`;
  return result.trim().replace('  ', ' ');
}
